<template>
  <div>

     <!-- Contact Description-->
    <div id="contactDescription" class="grid-container full container">
      <div class="grid-x grid-padding-x grid-container">
        <div class="cell">
            <h2>
              Contact Us
            </h2>
            <p>
              You can also contact our offices in :
            </p>
        </div>
        <div class="cell large-6 left-intro container">
         
          <p class="font-bold h5 padding-bottom-1">
            China
          </p>
          <p>
            <b>P: </b> <a href="tel:008683520905">(+86) 8352-0905</a> 
          </p>
          <p>
            <b>E: </b> <a href="mailto:operator@gzone1.com">operator@gzone1.com</a>
          </p>
          <p>
            <b>Address: </b> 
 
            19D, Rongjian Building, No. 29 Jianshe Liu Road, Yuexiu District, Guangzhou，China

          </p>
        </div>

        <div class="cell large-6 left-intro container">
          <p class="font-bold h5 padding-bottom-1">
            Cairo
          </p>
          <p>
            <b>P: </b> <a href="tel:00201096222212">002-01096222212</a> 
          </p>
          <p>
            <b>E: </b> <a href="mailto:sales@gzone1.com">sales@gzone1.com</a>/ <a href="mailto:amr@gzone1.com">amr@gzone1.com</a>
          </p>
          <p>
            <b>Address: </b> 
 
            12 Ahram St Elmoqqattam , Cairo , Egypt

          </p>
        </div>

        
      </div>
    </div>

    <!--Space-->
    <div class="container"></div>
  </div>
</template>

<script>
import "owl.carousel";

export default {
  name: "contactPage",
  mounted() {
    let { owlDemo } = this.$refs;

    // $(owlDemo).owlCarousel({
    //   navigation: true, // Show next and prev buttons
    //   slideSpeed: 300,
    //   paginationSpeed: 400,
    //   singleItem: true,

    //   // "singleItem:true" is a shortcut for:
    //   // items : 1,
    //   // itemsDesktop : false,
    //   // itemsDesktopSmall : false,
    //   // itemsTablet: false,
    //   // itemsMobile : false
    // });
    var owl = $(owlDemo);
    owl.owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      items: 1,
    });

    // Custom Button
    $(".customNextBtn").click(function() {
      owl.trigger("next.owl.carousel");
    });
    $(".customPreviousBtn").click(function() {
      owl.trigger("prev.owl.carousel");
    });
  },
};
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";

img {
  max-width: 100%;
  width: auto\9;
  height: auto;
  vertical-align: middle;
  border: 0;
  -ms-interpolation-mode: bicubic;
}

#owl-demo .item img {
  display: block;
  width: 100%;
  height: auto;
}

.owl-carousel .item {
  //height: 30rem !important;
  //background: #4dc7a0;
  padding: 1rem;
}
.btns {
  display: table;
  margin: 30px auto;
}
.customNextBtn,
.customPreviousBtn {
  float: right;
  background: #2d9070;
  color: #fff;
  padding: 10px;
  margin-left: 5px;
  cursor: pointer;
}
</style>
